import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import { NgSelectizeModule } from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ExchangeComponent } from './exchange.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      NgSelectizeModule,
      FontAwesomeModule
    ],
    declarations: [
      ExchangeComponent,
    ],
  })
  export class ExchangeModule { }



// WEBPACK FOOTER //
// ./src/app/exchange/exchange.module.ts